import { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";

const DefaultLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    localStorage.getItem("sidebar-expanded") === "true",
  );

  return (
    <div className="flex h-screen bg-white font-plus overflow-hidden">
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />

      <div className={`flex flex-col flex-1 min-w-0 transition-all duration-300 h-screen ${sidebarOpen ? "lg:ml-0" : ""} ${sidebarCollapsed ? "lg:ml-16" : "lg:ml-56"}`}>
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
        />

        <main className="flex-1 flex flex-col overflow-hidden min-h-0 relative">
          {children}
        </main>
      </div>
    </div>

  );
};

export default DefaultLayout;
